<template>
  <div>
    <ItemPanel v-for="(container, index) in containerPurchasingList" :key="index" icon="fa-container-storage" class="w-100" showTools>
      <template #tools>
        <router-link :to="{ path: '/purchasing/purchaseorders/new', query: { bulkData: generatePOData(container) } }" target="_blank" class="btn btn-primary">
          <i class="far fa-plus-square"></i> Create Purchase Order
        </router-link>
      </template>
      <template #title>
        <strong>Container #{{index + 1}} - {{ container.preferredSupplierName }}</strong>
      </template>
      <template #description>
        {{container.stockContainerName}}
      </template>
      <template #content>
        <ItemPanelData title="Supplier">
          <LinkContact :id="container.preferredSupplierId" :name="container.preferredSupplierName" />
        </ItemPanelData>
        <ItemPanelData title="Container">
          {{container.stockContainerName}}
        </ItemPanelData>
        <ItemPanelData title="Container Size">
          {{container.stockContainerBlockQuantity}} Blocks
        </ItemPanelData>
        <ItemPanelData title="Supplier Lead Time">
          {{container.preferredSupplierLeadDays}} Days
        </ItemPanelData>

        <FormHorizontalRule />
        <ContentTitle>Required Blocks</ContentTitle>
        <StaticDataTable smallRows :striped="false" :hover="false">
          <template #header>
            <tr>
              <th>Stock</th>
              <th>Glass Size</th>
              <th>Blocks</th>
              <th>Block Size</th>
              <th>Total Sheets</th>
            </tr>
          </template>
          <template #body>
            <tr v-for="(blockInfo, itemIndex) in getRequiredBlockList(container)" :key="itemIndex">
              <td><LinkStock :id="blockInfo.stockId" :name="blockInfo.stockName" /></td>
              <td>{{blockInfo.height}} x {{blockInfo.width}}</td>
              <td>{{blockInfo.quantity}}</td>
              <td>{{blockInfo.blockSize}}</td>
              <td>{{blockInfo.totalSheets}}</td>              
            </tr>
          </template>
        </StaticDataTable>

      </template>
    </ItemPanel>
  </div>
</template>


<script>
import moment from 'moment'

export default {
  name: 'PurchaseOrderContainerPurchaseList',
  props: {
    containerPurchasingList: Array
  },
  methods: {
    generatePOData(container) {
      return JSON.stringify({
        contactId: container.preferredSupplierId,
        notes: container.purchaseOrderNotes || '',
        date: moment().local().add(container.preferredSupplierLeadDays, 'days').format('YYYY-MM-DD'),
        items: container.requiredBlocks.map(block => ({
          // Abbreviated keys to reduce URL length
          s: block.stockId,
          q: block.quantity,
          gsid: block.glassSizeId
        }))
      })
    },
    getRequiredBlockList(container) {
      return _.compact(container.requiredBlocks.map(block => {
        let itemInfo = container.itemList.find(item => item.stockId === block.stockId && item.mainGlassSizeId === block.glassSizeId)
        if(!itemInfo)
          return null

        return {
          ...block,
          stockName: `${itemInfo.stockCode} - ${itemInfo.stockName}`,
          width: itemInfo.width,
          height: itemInfo.height,
          blockSize: itemInfo.blockSize,
          totalSheets: itemInfo.blockSize * block.quantity
        }
      }))
    }
  }
}
</script>